import { useTranslation } from "react-i18next";
import ErrorPage from "../src/components/ErrorPage";

const UnmatchedScreen = () => {
  const { t } = useTranslation();

  return (
    <ErrorPage
      title={t("screens.unmatched.title")}
      description={t("screens.unmatched.description")}
    />
  );
};

export default UnmatchedScreen;
